import PageBackTitle from "../Component/PageBackTitle";
import React, { useState } from "react";
// import "./UserForm.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import Select from "react-select";
import { parseMiApiError } from "./miIndexUtils";

function AddLocation({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const [locationData, setLocationData] = useState({
    location_name: "",
    location_type: "",
    region: "",
    state_office: "",
    zone: "",
    tankage_capacity: "",
  });

  const locationTypeOptions = ["Depot", "Terminal", "AFS"];
  const zoneOptions = ["A", "B", "C"];

  const locationTypeOptionsFormatted = locationTypeOptions.map((type) => ({
    value: type,
    label: type,
  }));

  const zoneOptionsFormatted = zoneOptions.map((zone) => ({
    value: zone,
    label: zone,
  }));

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setLocationData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleCancelClick = () => {
    navigate(`/mi-locations`);
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!locationData.location_name.trim()) {
      validationErrors.location_name = "Location name is required.";
    }

    if (!locationData.location_type) {
      validationErrors.location_type = "Location type is required.";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSaveClick = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const payload = {
        location_name: locationData.location_name.trim(),
        location_type: locationData.location_type,
        region: locationData.region.trim() || null,
        state_office: locationData.state_office.trim() || null,
        zone: locationData.zone || null,
        tankage_capacity: locationData.tankage_capacity
          ? parseFloat(locationData.tankage_capacity)
          : null,
      };

      const response = await axios.post(
        `${API_URL}/api/mi/locations`,
        payload,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 201) {
        setSeverity("success");
        showSnackbar(response.data?.message || "Location added successfully");
        setTimeout(() => {
          navigate(`/mi-locations`);
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving location:", error.message);
      setSeverity("error");
      const errorMessage = parseMiApiError(error, "Failed to save location");
      showSnackbar(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New Location</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail">
              <div className="new-data-form">
                <div className="form-group">
                  <label htmlFor="location_name">
                    Location Name<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="location_name"
                      value={locationData.location_name}
                      onChange={handleInputChange}
                      placeholder="Enter location name"
                    />
                  </div>
                  {errors.location_name && (
                    <div className="error-message">{errors.location_name}</div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="location_type">
                    Location Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="location_type"
                    placeholder="Select Location Type"
                    options={locationTypeOptionsFormatted}
                    value={
                      locationTypeOptionsFormatted.find(
                        (opt) => opt.value === locationData.location_type
                      ) || null
                    }
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "location_type",
                          value: selected ? selected.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                  {errors.location_type && (
                    <div className="error-message">{errors.location_type}</div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="region">Region</label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="region"
                      value={locationData.region}
                      onChange={handleInputChange}
                      placeholder="Enter region"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="state_office">State Office</label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="state_office"
                      value={locationData.state_office}
                      onChange={handleInputChange}
                      placeholder="Enter state office"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="zone">Zone</label>
                  <Select
                    name="zone"
                    placeholder="Select Zone"
                    options={zoneOptionsFormatted}
                    value={
                      zoneOptionsFormatted.find(
                        (opt) => opt.value === locationData.zone
                      ) || null
                    }
                    onChange={(selected) =>
                      handleInputChange({
                        target: {
                          name: "zone",
                          value: selected ? selected.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="tankage_capacity">Tankage Capacity</label>
                  <div className="input-group">
                    <input
                      type="number"
                      step="0.01"
                      name="tankage_capacity"
                      value={locationData.tankage_capacity}
                      onChange={handleInputChange}
                      placeholder="Enter tankage capacity"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default AddLocation;
